var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.versionList.length,
          expression: "versionList.length"
        }
      ]
    },
    _vm._l(_vm.versionList, function(version, index) {
      return _c("notice", {
        key: index,
        attrs: {
          isShowClose: true,
          close: _vm.close,
          rawData: index,
          title: _vm.getTitle(version),
          describe: version[_vm.$i18n.locale] || version.en
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }